import { REPORTS_DATA } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const fromDate = moment().subtract(1, "days").valueOf();
const toDate = new Date().getTime();

const initialState = {
  interval_report_data: {},
  abandoned_call_report: {},
  disposition_status_data: {},
  queue_base_inbound_reports: {},
  create_web_crawler: '',
  from_and_to_time_stamp: {
    fromDateDay: fromDate,
    toDateDay: toDate,
    fromMulti: fromDate,
    toMulti: toDate,
    fromLine: fromDate,
    toLine: toDate,
    fromPie: fromDate,
    toPie: toDate,
  },
  stack_from_to_time: {
    from_time: fromDate,
    to_time: toDate,
  },
  multi_from_to_time: {
    from_time: fromDate,
    to_time: toDate,
  },
  line_from_to_time: {
    from_time: fromDate,
    to_time: toDate,
  },
  pie_from_to_time: {
    from_time: fromDate,
    to_time: toDate,
  },

  highlight_for_analytics: {
    highDayStack: true,
    highWeekStack: false,
    highMonthStack: false,
    highDayMulti: true,
    highWeekMulti: false,
    highMonthMulti: false,
    highDayLine: true,
    highWeekLine: false,
    highMonthLine: false,
    highDayPie: true,
    highWeekPie: false,
    highMonthPie: false,
  },
  labels_data_for_abonded_calls: {
    labels: [] as any,
    datas: [] as any,
  } as any,
  no_data_found: {
    stack_chart: false,
    multi_chart: false,
    line_chart: false,
    pie_chart: false,
  } as any,

  stack_loader: false,
  multi_loader: false,
  line_loader: false,
  pie_loader: false,
  whole_time_change: false,
};

const reportsDataSlice = createSlice({
  name: REPORTS_DATA,
  initialState,
  reducers: {
    intervalReport: (state, { payload }) => {
      state.interval_report_data = payload.interval_report_data;
    },
    abondedCallReport: (state, { payload }) => {
      state.abandoned_call_report = payload.abandoned_call_report;
    },
    dispositionStatusReport: (state, { payload }) => {
      state.disposition_status_data = payload.disposition_status_data;
    },
    queueBaseInboundReports: (state, { payload }) => {
      state.queue_base_inbound_reports = payload.queue_base_inbound_reports;
    },
    createWebCrawler: (state, { payload }) => {
      state.create_web_crawler = payload.create_web_crawler;
    },
    fromAndToTimeStamp: (state, { payload }) => {
      state.from_and_to_time_stamp = payload.from_and_to_time_stamp;
    },

    stackFromToTimeChange: (state, { payload }) => {
      state.stack_from_to_time.from_time = payload.from_time;
      state.stack_from_to_time.to_time = payload.to_time;
    },
    multiFromToTimeChange: (state, { payload }) => {
      state.multi_from_to_time.from_time = payload.from_time;
      state.multi_from_to_time.to_time = payload.to_time;
    },
    lineFromToTimeChange: (state, { payload }) => {
      state.line_from_to_time.from_time = payload.from_time;
      state.line_from_to_time.to_time = payload.to_time;
    },
    pieFromToTimeChange: (state, { payload }) => {
      state.pie_from_to_time.from_time = payload.from_time;
      state.pie_from_to_time.to_time = payload.to_time;
    },

    highlightForAnalytics: (state, { payload }) => {
      state.highlight_for_analytics = payload.highlight_for_analytics;
    },
    labelsDataForAbondedCalls: (state, { payload }) => {
      state.labels_data_for_abonded_calls.labels = payload.labels;
      state.labels_data_for_abonded_calls.datas = payload.data;
    },
    noDataFoundStackChart: (state, { payload }) => {
      state.no_data_found.stack_chart = payload;
    },
    noDataFoundMultiChart: (state, { payload }) => {
      state.no_data_found.multi_chart = payload;
    },
    noDataFoundLineChart: (state, { payload }) => {
      state.no_data_found.line_chart = payload;
    },
    noDataFoundPieChart: (state, { payload }) => {
      state.no_data_found.pie_chart = payload;
    },
    stackLoader: (state, { payload }) => {
      state.stack_loader = payload;
    },
    multiLoader: (state, { payload }) => {
      state.multi_loader = payload;
    },
    lineLoader: (state, { payload }) => {
      state.line_loader = payload;
    },
    pieLoader: (state, { payload }) => {
      state.pie_loader = payload;
    },
    wholeTimeChange: (state, { payload }) => {
      state.stack_from_to_time.from_time = payload.from_time;
      state.stack_from_to_time.to_time = payload.to_time;
      state.multi_from_to_time.from_time = payload.from_time;
      state.multi_from_to_time.to_time = payload.to_time;
      state.line_from_to_time.from_time = payload.from_time;
      state.line_from_to_time.to_time = payload.to_time;
      state.pie_from_to_time.from_time = payload.from_time;
      state.pie_from_to_time.to_time = payload.to_time;
    },

    reset: () => { },
  },
});
export const reportsDataSliceActions = reportsDataSlice.actions;
export default reportsDataSlice.reducer;
